import React from 'react';

// Server text (tool descriptions, INSTRUCTIONS) carries two kinds of markup to
// render: **bold**, and tool names (task_list, wiki_get(...)) shown as code.
// Split into nodes rather than building HTML for dangerouslySetInnerHTML.
const TOKEN = /(\*\*.+?\*\*|\b(?:task|worklog|wiki|project)_[a-z_]+(?:\([^)]*\))?)/g;

export const InlineText: React.FC<{ text: string }> = ({ text }) => (
  <>
    {text.split(TOKEN).map((part, i) => {
      if (i % 2 === 0) return part;
      if (part.startsWith('**')) return <strong key={i}>{part.slice(2, -2)}</strong>;
      return (
        <code key={i} className="rounded bg-gray-100 px-1 text-[0.85em]">
          {part}
        </code>
      );
    })}
  </>
);
